import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from 'common/components';
import { useAppDispatch, useAppSelector } from 'common/hooks/redux';
import ButtonSection from '../ButtonSection';
import { Wrapper, DividerStyled } from './styles';
import EmailChangedPopUp from '../EmailChangedPopUp';
import ChangeEmailModal from '../ChangeEmailModal';
import { clinicOwnerVerifyOldEmail } from 'applicaiton/store/reducers/ClinicOwner/ActionCreators';
import {
  resetCOError,
  resetEmailData,
} from 'applicaiton/store/reducers/ClinicOwner/ClinicOwnerSlice';
import { useEmailForm } from '../../hooks/useEmailForm';

const Email: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const { currentClinicOwner, isVerifiedOldEmail, error } = useAppSelector(
    (state) => state.clinicOwnerSlice,
  );
  const [showEmailPopUp, setShowEmailPopUp] = useState(false);
  const [isEmailExist, setIsEmailExist] = useState(false);

  const { register, errors, handleSubmit, watch, setValue } = useEmailForm({
    requiredError: t('errors.required'),
  });

  useEffect(() => {
    return () => {
      dispatch(resetCOError());
    };
  }, []);

  useEffect(() => {
    setValue('email', currentClinicOwner?.user?.email || '');
  }, [currentClinicOwner]);

  const handleCloseModal = () => {
    isEmailExist && setIsEmailExist(false);
    setShowEmailPopUp(false);
  };

  const handleCloseEmailChangeModal = () => {
    setValue('email', currentClinicOwner?.user?.email || '');
    dispatch(resetEmailData());
  };

  const handleOpenForm = async () => {
    sessionStorage.setItem('newEmail', watch('email'));
    sessionStorage.setItem('oldEmail', String(currentClinicOwner?.user?.email));
    setShowEmailPopUp(false);

    dispatch(
      clinicOwnerVerifyOldEmail({
        email: String(currentClinicOwner?.user?.email),
      }),
    );
  };

  const onSubmit = () => {
    setShowEmailPopUp(true);
  };

  return (
    <Wrapper onSubmit={handleSubmit(onSubmit)}>
      <div>
        <Input
          id="email"
          type={'email'}
          label={t('email') || ''}
          register={register}
          errorMessage={
            errors.email?.message || (error && t('error_attempt_limit')) || ''
          }
        />
      </div>
      <div>
        <DividerStyled />
        <ButtonSection
          disabled={
            !!Object.keys(errors).length ||
            watch('email') === currentClinicOwner?.user?.email
          }
        />
      </div>
      {showEmailPopUp && (
        <EmailChangedPopUp
          onClose={handleCloseModal}
          onSubmit={handleOpenForm}
        />
      )}
      {isVerifiedOldEmail && (
        <ChangeEmailModal
          isOpen={isVerifiedOldEmail}
          onClose={handleCloseEmailChangeModal}
        />
      )}
    </Wrapper>
  );
};

export default Email;
